class State {
    titulo = "Contenidos"
    tituloCompleto = "Sistema de Contenidos Dinámicos"
}

const state = new State()

export default state